import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import api from "../api/axios";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";

const Slider = () => {
  const [sliders, setSlider] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState([]);
  const [filterText, setFilterText] = useState("");
  const history = useHistory();

  const fetchSlider = async () => {
    try {
      const response = await api.post(`/slider/get`);
      if (response.data.success) {
        setSlider(response.data.slider);
      } else {
        setError("Slider not found");
      }
    } catch (err) {
      setError("Error fetching slider details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSlider();
  }, []);

  const filteredSliders = sliders.filter((item) => {
    const name = typeof item.name === "string" ? item.name : "";
    return name.toLowerCase().includes(filterText.toLowerCase());
  });

  const deleteSlider = async (e, id) => {
    e.preventDefault();
    try {
      const response = await api.post(`/slider/delete/${id}`);
      if (response) {
        fetchSlider();
        toast.success("Slider Delete Success");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const addSlider = async (e, id) => {
    try {
      e.preventDefault();
      localStorage.setItem("slider-list", null);
      history.push("add-edit-slider");
    } catch (error) {
      console.log(error);
    }
  };

  const editSlider = async (e, row) => {
    try {
      e.preventDefault();
      localStorage.setItem("slider-list", JSON.stringify(row));
      history.push("add-edit-slider");
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      name: "id",
      selector: (row) => row.id,
      sortable: true,
      width: "120px",
    },
    {
      name: "Image",
      cell: (row) => (
        <img
          src={`https://sachiproduct-backend.theaditech.in/${row.image}`}
          alt={row.name}
          width="80"
          height="50"
          style={{ borderRadius: "8px" }}
        />
      ),
      width: "200px",
    },
    {
      name: "Name",
      selector: (row) => row.name || "N/A",
      sortable: true,
      width: "250px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex gap-2">
          <button className="btn btn-lg" onClick={(e) => editSlider(e, row)}>
            <i className="icon-edit-3"></i>
          </button>
          <button
            className="btn btn-lg"
            onClick={(e) => deleteSlider(e, row.id)}
          >
            <i className="icon-trash-2"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
  return (
    <>
      <div className="main-content-inner">
        {/* <!-- main-content-wrap --> */}
        <div className="main-content-wrap">
          <div className="flex items-center flex-wrap justify-between gap20 mb-27">
            <h3>Sliders List</h3>
            <ul className="breadcrumbs flex items-center flex-wrap justify-start gap10">
              <li>
                <Link to="/dashboard">
                  <div className="text-tiny">Dashboard</div>
                </Link>
              </li>
              <li>
                <i className="icon-chevron-right"></i>
              </li>
              <li>
                <div className="text-tiny">Slider List</div>
              </li>
            </ul>
          </div>
          {/* <!-- product-list --> */}
          <div className="wg-box">
            <div className="flex justify-end">
              <Link
                className="tf-button style-1 w208"
                // to="add-product"
                onClick={(e) => addSlider(e)}
                style={{
                  textDecoration: "none",
                }}
              >
                <i className="icon-plus"></i>Add new
              </Link>
            </div>

            {error && <p className="text-danger">{error}</p>}

            {/* Search Input */}
            <div className="datatable-container col-md-7">
              <div className="datatable-header">
                <input
                  type="text"
                  placeholder="Search product..."
                  className="datatable-search"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
                {filterText && (
                  <button
                    className="datatable-clear"
                    onClick={() => setFilterText("")}
                  >
                    ✕
                  </button>
                )}
              </div>
              <DataTable
                columns={columns}
                data={filteredSliders}
                progressPending={loading}
                pagination
                highlightOnHover
                striped
                responsive
                defaultSortField="name"
              />
              <div className="divider"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Slider;
